<script>
export default {
  name: "IconGridHorizontalRound",
}
</script>

<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none"><path d="M10 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0"/></svg>
</template>
